<template>
    <modal name="welcome" @before-open="beforeOpen" @before-close="beforeClose" :classes="['v--modal', 'welcome']"
        :width="400" :height="'auto'" :scrollable="true" :adaptive="true">
        <div class="modal-close" @click="close"></div>
        <div class="modal-body">
            <div class="modal-title-alt">{{ $t("welcomeModal.firstTimeHere") }}</div>
            <div class="modal-subtitle">
                {{ $t("welcomeModal.logInToYourAccount") }}
            </div>
            <div class="welcome-buttons">
                <button @click="$modal.hide('welcome'); $modal.show('register')" type="button" class="button-blue">{{
                    $t("welcomeModal.registration") }}</button>
                <button @click="$modal.hide('welcome'); $modal.show('login')" type="button" class="button">
                    {{ $t("welcomeModal.signIn") }}
                </button>
            </div>
            <span @click="$modal.hide('welcome'); $modal.show('reset-password')" class="link reset-password">
                {{ $t("welcomeModal.restoreAccess") }}
            </span>
        </div>
    </modal>
</template>

<script>
import { checkScroll } from '@/mixins/checkScroll';

export default {
    name: 'WelcomeModal',
    props: {
        i18n: Object,
    },
    mixins: [
        checkScroll
    ],
    data() {
        return {
        }
    },
    methods: {
        beforeOpen() {
            this.checkScroll();
        },
        beforeClose() {
            this.checkRemoveScroll();
        },
        close() {
            this.$modal.hide('welcome');
        },
    }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/layout/_welcome';
</style>
